import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AjaxData, AjaxService } from '../core/ajax.service';
import { ApiRoutesV1 } from '../common/routes';

@Injectable()
export class PreviewService {
  constructor(private readonly ajaxService: AjaxService) {}

  public getEmailPreview(templateId: string): Observable<string> {
    return this.ajaxService
      .get(ApiRoutesV1.templateRender, {
        params: {
          templateId: templateId,
        },
      })
      .pipe(map((response: HttpResponse<AjaxData>) => response.body.data));
  }
}
